import React from "react";
import { Skeleton, Card } from "antd";
import { motion } from "framer-motion";

export const ShimmerCard: React.FC<{ height?: number }> = ({ height = 120 }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Card style={{ height }}>
        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>
    </motion.div>
  );
};

export const ShimmerMetric: React.FC<{ delay?: number }> = ({ delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3, delay }}
    >
      <Card>
        <Skeleton.Input active size="small" style={{ width: 100, marginBottom: 8 }} />
        <Skeleton.Input active size="large" style={{ width: 80 }} />
      </Card>
    </motion.div>
  );
};

export const ShimmerTable: React.FC = () => {
  return (
    <Card>
      <Skeleton active paragraph={{ rows: 6 }} />
    </Card>
  );
};
